module.exports = __webpack_public_path__ + "static/img/10.9f25a54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/sp/10.png
// module id = h583
// module chunks = 0